import React, { useEffect, useState } from 'react';
import { urls } from '../../settings';

import './CarouselImages.scss';

const CarouselImages = ({ arrImagem }) => {
  const [posicao, setPosicao] = useState(0);
  const [desabilitarProximo, setDesabilitarProximo] = useState(false);
  const [desabilitarAnterior, setDesabilitarAnterior] = useState(false);

  const proximo = () => {
    if (posicao + 1 === arrImagem.length) {
      setPosicao(arrImagem.length - 1);
      return;
    }
    setDesabilitarAnterior(false);
    setPosicao(posicao + 1);
  };

  const anterior = () => {
    if (posicao === 0) {
      setPosicao(0);
      return;
    }
    setDesabilitarProximo(false);

    setPosicao(posicao - 1);
  };

  useEffect(() => {
    if (posicao + 1 === arrImagem.length) {
      setDesabilitarProximo(true);
    }

    if (posicao === 0) {
      setDesabilitarAnterior(true);
    }
  }, [posicao, arrImagem.length]);

  return (
    <div className="carousel-images">
      <div>
        <img src={arrImagem[posicao].imagem} alt={arrImagem[posicao].descricao} />
      </div>
      <div className="carousel-images-conteudo">
        <div>
          <p>{arrImagem[posicao].descricao}</p>
        </div>
        <div className="carousel-images-botao">
          <button onClick={anterior} disabled={desabilitarAnterior}>
            <img src={`${urls.assets}img/carousel-images/anterior.png`} alt="Anterior"/>
          </button>
          <p>
            <b>{posicao + 1}</b> de {arrImagem.length}
          </p>
          <button onClick={proximo} disabled={desabilitarProximo}>
            <img src={`${urls.assets}img/carousel-images/proximo.png`} alt="Próximo"/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarouselImages;
